module.exports = __webpack_public_path__ + "img/play_arrow.51940030.svg";